import { ButtonGroup, ButtonMantine, Grid, useButtonGroupContext } from 'ui';

const PeerCreditButton = ({ value, label }: { value: string | undefined; label: string }) => {
  const context = useButtonGroupContext();

  const contextProps = context
    ? {
        onclick: context.onClick,
        value: context.value,
        activeButton: context.activeButton,
      }
    : {};

  const onClick = () => {
    if (contextProps.onclick) {
      contextProps.onclick({ value: value });
    }
  };

  const active = contextProps.activeButton?.value == value;
  return (
    <ButtonMantine w="100%" value={value} data-active={active} onClick={onClick}>
      {label}
    </ButtonMantine>
  );
};

const PeerCreditButtonGroup = ({
  value,
  onChange,
  isParticipantsEnabled,
  isTeamsEnabled,
  translations,
}: {
  value?: string;
  onChange: (value: { value?: number | string; label?: string }) => void;
  isParticipantsEnabled?: boolean;
  isTeamsEnabled?: boolean;
  translations?: {
    donate?: string;
    participant?: string;
    team?: string;
  };
}) => {
  const teamsColSpan = isParticipantsEnabled ? 6 : 'auto';
  return (
    <ButtonGroup value={{ value: value }} onChange={onChange}>
      {isParticipantsEnabled && (
        <Grid.Col span="auto">
          <PeerCreditButton value="participants" label={`${translations?.participant}`} />
        </Grid.Col>
      )}
      {isTeamsEnabled && (
        <Grid.Col span={{ md: teamsColSpan }}>
          <PeerCreditButton value="teams" label={`${translations?.team}`} />
        </Grid.Col>
      )}
      <Grid.Col span="auto">
        <PeerCreditButton value={''} label={`${translations?.donate} without crediting anyone`} />
      </Grid.Col>
    </ButtonGroup>
  );
};

export { PeerCreditButtonGroup };
